module.exports = __webpack_public_path__ + "img/coinsmart.3911cf48.svg";